import { Component, ElementRef, OnInit, viewChild } from '@angular/core';
import { SplashScreen } from '@capacitor/splash-screen';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { AdMob, BannerAdPluginEvents } from '@capacitor-community/admob';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  imports: [IonApp, IonRouterOutlet],
})
export class AppComponent implements OnInit {
  // Get the router outlet

  private readonly routerOutlet = viewChild.required(IonRouterOutlet, {
    read: ElementRef,
  });
  ngOnInit(): void {
    setTimeout(
      async () => await SplashScreen.hide({ fadeOutDuration: 200 }),
      1250,
    );
    AdMob.addListener(BannerAdPluginEvents.SizeChanged, (info) => {
      this.routerOutlet().nativeElement.style.marginBottom = info.height + 'px';
    });
  }
}
